import React from "react";
import Accordion from "react-bootstrap/Accordion";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Dropdown from "react-bootstrap/Dropdown";
import DropdownButton from "react-bootstrap/DropdownButton";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import Utils from "../../services/Utils";
import { ReactComponent as PictoChallenge } from "../../assets/svg/challenge.svg";

const AccordionChallengesType = ({
  challengeType,
  deleteChallengeType,
  handleShowUpdate,
}) => {
  return (
    <div>
      <Accordion>
        <Accordion.Item
          eventKey="0"
          className="mb-4 w-100 m-auto"
          style={{
            backgroundColor: Utils.getColorAlternative(challengeType.color, 20),
          }}
        >
          <div className="row w100">
            <div className="col-10">
              <Accordion.Header as="div">
                <div className="row w100">
                  <div className="col-10">
                    <div className="mr-2 text-start ">
                      <span
                        style={{ backgroundColor: challengeType.brand.color }}
                        className="rounded white marque"
                      >
                        {challengeType.brand.name}
                      </span>
                      <span
                        className="accordion-title accordion-user-name me-3"
                        style={{ color: challengeType.color }}
                      >
                        {challengeType.name}
                      </span>
                      <PictoChallenge
                        className="ms-3"
                        alt="Challenge"
                        style={{
                          width: 24,
                          height: 24,
                          fill: challengeType.color,
                        }}
                      />
                    </div>
                  </div>
                </div>
              </Accordion.Header>
            </div>
            <div className="col-2 text-end  pt-2">
              <DropdownButton title={<MoreVertIcon />} className="hidden-arrow">
                <Dropdown.Item
                  onClick={() => {
                    handleShowUpdate(challengeType);
                  }}
                >
                  <EditOutlinedIcon className="grey" /> Modifier
                </Dropdown.Item>
                <Dropdown.Item
                  onClick={() => {
                    deleteChallengeType(challengeType.id);
                  }}
                >
                  <DeleteOutlinedIcon className="red" /> Supprimer
                </Dropdown.Item>
              </DropdownButton>
            </div>
          </div>

          <div className="container-fluid p-0">
            <Accordion.Body>
              <div className="row">
                <div className="col-md-6 pt-5 px-4 have-border-top">
                  <div className="data-label pb-3">Nom challenge</div>
                  <p>{challengeType.name}</p>
                </div>
                <div className="col-md-6 pt-5 px-4 have-border-top have-border-left">
                  <div className="data-label pb-3">Couleur challenge</div>
                  <p>
                    <PictoChallenge
                      className="sidebarIcon ms-3"
                      alt="Challenge"
                      style={{
                        width: 24,
                        height: 24,
                        fill: challengeType.color,
                      }}
                    />
                    {" " + challengeType.color}
                  </p>
                </div>
              </div>
            </Accordion.Body>
          </div>
        </Accordion.Item>
      </Accordion>
    </div>
  );
};
export default AccordionChallengesType;
